import { type RefObject, useEffect, useState } from 'react';

export function useStickyCtaVisibility(
  heroEndRef: RefObject<HTMLDivElement | null>,
  anchorId?: string,
) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      if (!heroEndRef.current) {
        setIsVisible(false);
        return;
      }

      const pastHero = heroEndRef.current.getBoundingClientRect().bottom < 0;

      const anchor = anchorId ? document.getElementById(anchorId) : null;

      if (!anchor) {
        setIsVisible(pastHero);
        return;
      }

      const { top, bottom } = anchor.getBoundingClientRect();
      const viewportHeight =
        window.visualViewport?.height ?? window.innerHeight;

      setIsVisible(pastHero && !(top < viewportHeight && bottom > 0));
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    window.visualViewport?.addEventListener('resize', updateVisibility);

    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
      window.visualViewport?.removeEventListener('resize', updateVisibility);
    };
  }, [heroEndRef, anchorId]);

  return isVisible;
}
